export const UserTypes = {
  CUSTOMER: 'CUSTOMER',
  BUILDER: 'BUILDER',
  CENTRIC: 'CENTRIC',
  DEVELOPER: 'DEVELOPER'
};

export const UserRoleTypes = { CUSTOMER: 2, BUILDER: 3, CENTRIC: 4, DEVELOPER: 5 };

export const CommonDefaultPassword = 'BVEgE24u30zP8ueM!';
export const ServiceGroupType = { GAS: ['GAS'], FIBER: ['FIBER', 'VOIP', 'TV'] };

export const ServiceType = { GAS: 'GAS', FIBER: 'FIBER', VOIP: 'VOIP', TV: 'TV' };

export const PageType = {
  LANDING: 'LANDING',
  SERIVE: 'SERIVE',
  ACCOUNT: 'ACCOUNT',
  SUBACCOUNT: 'SUBACCOUNT',
  LOCATION: 'LOCATION'
};

export const ServiceRequestType = {
  FIBERLINE: 'fiberLine',
  GASMETER: 'gasMeter',
  GASLINE: 'gasLine',
  GENERAL: 'general',
  SERVICELINE: 'serviceLine'
};

export const AclModule = {
  MYPROFILE: 'MyProfileWidget', // not using in left menu
  OPTIONALLIST: 'OptionalListBox',  // not using in left menu
  PLANWIDGET: 'MyPlanWidget',  // not using in left menu
  QUICKACCESS: 'TicketQuickAccessWidget',  // not using in left menu
  MESSAGEBOX: 'MessageBoxWidget',
  ACCOUNTLOCATION: 'AccountLocationWidget',  // not using in left menu
  SERVICETICKET: 'ServiceTicketsWidget',
  SECURITYSETTINGS: "SecuritySettings",
  SELFSERVICE: 'SelfServiceWidget',  // not using in left menu
  FIBERTICKET: 'FiberTickets',  // not using in left menu
  GASTICKET: 'GasTickets',  // not using in left menu
  GENERALTICKET: 'GeneralTickets', // not using in left menu
  PROPERTIES: 'Properties',
  AUTHORIZEDUSER: 'AuthorizedUsers',  // not using in left menu
  ACCOUNTPREF: 'AccountPreferences',
  ACCOUNTS: 'Accounts',
  PAYMENTHISTORY: 'PaymentHistory',
  BILLINGHISTORY: 'BillingHistory',
  TRANSACTIONHISTORY: 'TransactionHistory',
  MANAGEPAYMENT: 'ManagePaymentMethods',
  GASHISTORY: 'GasUsageHistory',
  MANAGECONTACT: 'ManageContact',
  MANAGECOMMUNI: 'ManageCommunicationPreferences',
  ADMINSETTINGS: 'AdminSettings',  // not using in left menu
  PAYMENTREGADMIN: 'PaymentRegistrationAdmin',
  PAYMENTREGADMINACC: 'PaymentRegistrationAdminAccountCreate',  // not using in left menu
  FIBERSETTINGS: "FiberSettings",
  MANAGEDATAFILE: "ManageDataFile",
  RESOURCECENTER: "ResourceCenter",
  FAQs: "FAQS",
  CONTACTUS: "ContactUs",
  NETWORK: "NetWork",
  SUBSCRIBER: "Subscriber",
  ONTS: "Onts",
  MESSAGEQUEUE: "MessageQueue",
  MANAGEMYACCOUNT: "ManageMyAccount",
  DUNNINGDISCONNECTS: "DunningDisconnects",
  ACCOUNTDEPOSITS: "AccountDeposits",
  CREDITADJUSTMENTS: "CreditAdustments",
  ENTROLLMENTQUEUE: "EnrollmentQueue",
  ACCESSCONTROL: "AccessControl",
  MANAGEINTERNALUSERS: "ManageInternalUsers",
  MANAGEANNOUNCEMENTS: "ManageAnnouncements"
};
